import React from "react";
// Components
import { Button, mergeClasses, Tooltip } from "@fluentui/react-components";
import { Attach } from "@ms/planner-generic-controls/lib/local/icons";
// Styles
import { useStyles } from "./GroundingResourcesButton.styles";
// Utilities
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Button component for accessing grounding resources.
 * Collapses to icon-only when width is below the responsive threshold.
 */ export const GroundingResourcesButton = ({ onClick, showLabel })=>{
    const classNames = useStyles();
    return /*#__PURE__*/ React.createElement(Tooltip, {
        content: Strings.GroundingResourcesButton_Tooltip,
        relationship: "label",
        positioning: "above",
        withArrow: true
    }, /*#__PURE__*/ React.createElement(Button, {
        shape: "rounded",
        appearance: "secondary",
        className: mergeClasses(classNames.root, !showLabel && classNames.iconOnly),
        icon: /*#__PURE__*/ React.createElement(Attach, null),
        onClick: onClick,
        "data-testid": "grounding-resources-button"
    }, showLabel && Strings.FloatingActionButton_GroundingButtonText));
};
